export var SegmentDefinitionsStatusEnum;
(function (SegmentDefinitionsStatusEnum) {
    SegmentDefinitionsStatusEnum["ACTIVE"] = "active";
    SegmentDefinitionsStatusEnum["DEACTIVATED"] = "deactivated";
})(SegmentDefinitionsStatusEnum || (SegmentDefinitionsStatusEnum = {}));
export var SegmentVisibilityEnum;
(function (SegmentVisibilityEnum) {
    SegmentVisibilityEnum["VISIBLE"] = "visible";
    SegmentVisibilityEnum["HIDDEN"] = "hidden";
})(SegmentVisibilityEnum || (SegmentVisibilityEnum = {}));
/**
 * All potential types for a segment definition
 */
export var SegmentDefinitionTypeEnum;
(function (SegmentDefinitionTypeEnum) {
    /**
     * Default segment definition that contains all users, this is uneditable/deletable by the user
     */
    SegmentDefinitionTypeEnum["ALL_USERS"] = "all_users";
    /**
     * These are VSAAS defined segment definitions that are uneditable/deletable by the user
     */
    SegmentDefinitionTypeEnum["MANAGED"] = "managed";
    /**
     * These are custom segment definitions that are editable/deletable by the user
     */
    SegmentDefinitionTypeEnum["CUSTOM"] = "custom";
    /**
     * These are one-off segment definitions that are associated in with an automation
     */
    SegmentDefinitionTypeEnum["ONE_OFF"] = "one_off";
    /**
     * These are SQL-defined segment definitions that use file-based SQL queries
     */
    SegmentDefinitionTypeEnum["SQL"] = "sql";
})(SegmentDefinitionTypeEnum || (SegmentDefinitionTypeEnum = {}));
//# sourceMappingURL=segment-definitions.js.map